var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loadingFinished)?_c('div',{staticClass:"appContent"},[_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('keep-alive',[_c('router-view',{key:_vm.$route.path})],1)],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }